import { widgetState } from '../../store/customizations/index'
import { ColorUtils } from '../../utils/colors'

export const frequencyTemplate = () => {
  return `
    <div class="yotpo-frequency-options">
        {{#values}}
        <label style="margin-bottom: 0" class="yotpo-frequency-option">
            <input name="frequency-{{groupId}}" class="yotpo-radio-label-input yotpo-select-radio-label" type="radio" value="{{value}}" data-label="{{label}}" {{#checked}} checked {{/checked}}>
            <span style="cursor: pointer" class="yotpo-frequency-label {{#checked}}yotpo-frequency-selected{{/checked}}" value="{{value}}">{{label}}</span>
        </label>
        {{/values}}
    </div>
    <style>
        .yotpo-widget-subscriptions-add-to-cart .yotpo-selling-plan-select-container {
          margin: 10px 45px 0 30px;
        }

        .yotpo-widget-subscriptions-add-to-cart .yotpo-frequency-options {
          display: grid;
        }

        .yotpo-widget-subscriptions-add-to-cart .yotpo-radio-label-input.yotpo-select-radio-label {
          margin: auto;
          cursor: pointer;
          min-height: auto;
        }

        .yotpo-widget-subscriptions-add-to-cart .yotpo-frequency-label {
          font-style: normal;
          font-family: ${widgetState.customizations.styles.fontFamily.name};
          font-weight: ${widgetState.customizations.styles.fontFamily.weight || 400};
          font-size: ${widgetState.customizations.styles.fontSize.sellingPlans.options};
          line-height: 20px;
          color: ${ColorUtils.getWithOpacity(widgetState.customizations.styles.colors.text.primary, '0.6')};
        }

        .yotpo-widget-subscriptions-add-to-cart .yotpo-frequency-label.yotpo-frequency-selected {
          color: ${widgetState.customizations.styles.colors.text.primary};
        }

        .yotpo-widget-subscriptions-add-to-cart .yotpo-radio-label-input.yotpo-select-radio-label {
          margin-right: 15px;
        }

        .yotpo-widget-subscriptions-add-to-cart .yotpo-frequency-option {
          padding: 5px 0;
          justify-self: baseline;
        }
    </style>`
}
